import ServicesDescription from "../../../../src/courses/partials/services/index.mdx";
import * as React from 'react';
export default {
  ServicesDescription,
  React
};